import { Component } from '@angular/core';
import * as $ from 'jquery';
import { Title }     from '@angular/platform-browser';
import { environment } from '../environments/environment';
import {UserService} from '../app/servies/user/user.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  {

  public user: any;

  public constructor(private titleService: Title ) { }

  ngOnInit() {
    this.titleService.setTitle( environment.appTitle );
    
  }
}
